import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import axios from "axios";
import DsBadge from "components/DsBadge";
import { TimePicker, Button, Select, Output, Accordion } from "@ds/ds-snam/react";
import { Input as TextInput } from "@ds/ds-snam/react";
import { IBooking, IBookingAddress } from "dataModels/b2b";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { getBusinessVehicle, loadAddressesOptionsAPI, postBooking } from "net/b2b";
import { selectorAPI } from "net/b2b";
//import { getBusinessVehicle } from "net/b2b";
import { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ResponseStatus, EntityType, RoutePath, VehicleType, ReservationPostType, FormMode, AppUserRole, DsLayout, CalendarSlotStatus, SnamPlantKey } from "shared/constants";
import { dsDeselectHandler, dsPreSelectHandler, dsSelectHandler } from "shared/utils/dsComponentUtils";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { buildPopUp } from "components/PopUp";
import { AppUser } from "ooAuth2/appUser";
import useAppUser from "hooks/useAppUser";
import { appStore, RootState } from "state/appStore";
import { myCountryArraySelect, myCountryArraySelectEN, provinceMap } from "shared/domains/formDomains";
import React from "react";
import BookingBioFields, { isBookingBioPercentageValid } from "./bookingBioFields";


interface IBookingReservationFormProps {
    bookingData: IBooking,
    edit:boolean,
    formMode:FormMode
}

interface IAddressOption {
    destinationBusinessName: string,
    destinationAddress: string,
    destinationNation: string,
    destinationStreetNumber: string,
    destinationPostalCode: string,
    destinationCity: string,
    destinationProvince: string,
    destinationVat: string,
}

const BookingReservationForm: React.FC<IBookingReservationFormProps> = (props): JSX.Element => {

    const { t } = useTranslation(["b2b", "app"]);
    const { bookingData } = props;
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const { i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [formData, setFormData] = useState<IBooking>(bookingData);

    const [provinceOptions, setProvinceOptions] = useState<ISelectLabel[]>([]);
    const [stateOptions,setStateOptions] = useState<ISelectLabel[]>([]);

    const [provinceOptionsList, setProvinceOptionsList] = useState<ISelectLabel[][]>([]);
    const [stateOptionsList, setStateOptionsList] = useState<ISelectLabel[][]>([]);

    
    const [serviceList, setServiceList] = useState<ISelectLabel[] | undefined>();
    const [typeVehicleList, setTypeVehicleList] = useState<ISelectLabel[] | undefined>();
    const [shipperList, setShipperList] = useState<ISelectLabel[] | undefined>();
    const [driversList, setDriversList] = useState<ISelectLabel[] | undefined>();
    const [transportList,setTransportList] = useState<ISelectLabel[] | undefined>();
    const [firstEdit,setFirstEdit] = useState(false);
    const [addressesOptions, setAddressesOptions] = useState<IAddressOption[]>([]);

    const [tankerTruckList, setTankerTruckList] = useState<ISelectLabel[] | undefined>();
    const [truckTractorList, setTruckTractorList] = useState<ISelectLabel[] | undefined>();
    const [isoContainerList, setIsoContainerList] = useState<ISelectLabel[] | undefined>();
    const [flatBedList, setFlatBedList] = useState<ISelectLabel[] | undefined>();
    const [forcedBayList, setForcedBayList] = useState<ISelectLabel[] | undefined>();
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })

    const plantIdValue: string|undefined = appStore.getState().plant.plantId;

    

    const loadAddressesOptions = (transporterId: string) => {
        if (transporterId === "") {
            setAddressesOptions([]);
            return;
        }
            dispatch(requestPending());
            loadAddressesOptionsAPI(transporterId)
                .then((response: any) => {
                    setAddressesOptions(response ?? []);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                })
        };




    const loadVehiclePostChangeService = (eventSelection: number) => {
        let currentFormData = { ...formData };
        (currentFormData['service' as keyof IBooking] as number) = Number(eventSelection);
        setFormData(currentFormData);
        if(currentFormData.transporterId!==""){
            let businessVehicleReq = getBusinessVehicle(bookingData.codeIup, eventSelection,currentFormData.transporterId);
            let driversListReq = selectorAPI(EntityType.DRIVER, bookingData.codeIup, eventSelection,currentFormData.transporterId);
            dispatch(requestPending());
            axios.all([businessVehicleReq, driversListReq])
            .then(axios.spread((...responses) => {
                dsPreSelectHandler(responses[0].typeVehicle as ISelectLabel[], responses[0].typeVehicle[0].value);
                setTruckTractorList(responses[0].truckTractor);
                setTankerTruckList(responses[0].tankerTruck);
                setIsoContainerList(responses[0].isoContainer);
                setFlatBedList(responses[0].flatBed);
                setTypeVehicleList(responses[0].typeVehicle);
                setDriversList(responses[1]);
                setFormData((prevFormData) => {
                    // Mantenere i valori precedenti e modificare solo quelli necessari
                    return {
                        ...prevFormData,
                        typeVehicle: Number(responses[0].typeVehicle[0].value),
                        flatBed: "",
                        isoContainer: "",
                        truckTractor: "",
                        tankerTruck: "",
                        driverId: "",
                    };
                });
            }))
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                dispatch(requestPristine())
            })
        }
        

    }

    const updateMenusForChangedTransporter = (currentFormData:IBooking,eventSelection:string) => {
        let businessVehicleReq = getBusinessVehicle(bookingData.codeIup, currentFormData.service,eventSelection);
        let driversListReq = selectorAPI(EntityType.DRIVER, bookingData.codeIup, currentFormData.service,eventSelection);
        dispatch(requestPending());
            axios.all([businessVehicleReq, driversListReq])
            .then(axios.spread((...responses) => {
                dsPreSelectHandler(responses[0].typeVehicle as ISelectLabel[], responses[0].typeVehicle[0].value);
                setTypeVehicleList(responses[0].typeVehicle);

                if(currentFormData.truckTractor!==""){
                    dsPreSelectHandler(responses[0].truckTractor as ISelectLabel[], currentFormData.truckTractor);
                }
                setTruckTractorList(responses[0].truckTractor);

                if(currentFormData.tankerTruck!==""){
                    dsPreSelectHandler(responses[0].tankerTruck as ISelectLabel[], currentFormData.tankerTruck);
                }
                setTankerTruckList(responses[0].tankerTruck);

                if(currentFormData.isoContainer!==""){
                    dsPreSelectHandler(responses[0].isoContainer as ISelectLabel[], currentFormData.isoContainer);
                }
                setIsoContainerList(responses[0].isoContainer);

                if(currentFormData.flatBed!==""){
                    dsPreSelectHandler(responses[0].flatBed as ISelectLabel[], currentFormData.flatBed);
                }
                setFlatBedList(responses[0].flatBed);
                
                if(currentFormData.driverId!==""){
                    dsPreSelectHandler(responses[1] as ISelectLabel[], currentFormData.driverId);
                }
                setDriversList(responses[1]);

                //Qui alla prima apertura della EDIT li pulisce, in quel caso non dovrei pulirli
                if(firstEdit===false){
                    setFirstEdit(true);
                }else{
                    setFormData((prevFormData) => {
                        // Mantenere i valori precedenti e modificare solo quelli necessari
                        return {
                            ...prevFormData,
                            typeVehicle: Number(responses[0].typeVehicle[0].value),
                            flatBed: "",
                            isoContainer: "",
                            truckTractor: "",
                            tankerTruck: "",
                            driverId: "",
                        };
                    });
                }
                

            }))
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                dispatch(requestPristine())
            })
    }

    const loadVehiclePostChangeTransporter = (eventSelection: string) => {
        let currentFormData = { ...formData };
        (currentFormData['transporterId' as keyof IBooking] as string) = eventSelection;
        setFormData(currentFormData);
    }

    useEffect(()=>{
        let currentFormData = { ...formData };
        if(formData.transporterId!==""){
            updateMenusForChangedTransporter(currentFormData,currentFormData.transporterId)
            loadAddressesOptions(currentFormData.transporterId);
        } else {
            setAddressesOptions([]);
        }
    },[formData.transporterId])

    const onOptionSelect = (id: string, event: Event) => {
        let selection = (event as CustomEvent).detail.option.value;
        if (id==="service") {
            loadVehiclePostChangeService(selection);
        }else if(id==='transporterId'){
            loadVehiclePostChangeTransporter(selection);
        } else {
            if(id==="typeVehicle"){
                let currentFormData = { ...formData };
                (currentFormData[id as keyof IBooking] as Number) = Number(selection);
                currentFormData.flatBed="";
                currentFormData.truckTractor="";
                currentFormData.tankerTruck="";
                currentFormData.isoContainer="";
                if(tankerTruckList!==undefined){
                    dsDeselectHandler(tankerTruckList)
                }
                if(truckTractorList!==undefined){
                    dsDeselectHandler(truckTractorList)
                }
                if(isoContainerList!==undefined){
                    dsDeselectHandler(isoContainerList)
                }
                if(flatBedList!==undefined){
                    dsDeselectHandler(flatBedList)
                }
                setFormData(currentFormData);
            }else{
                let currentFormData = { ...formData };
                if (typeof (currentFormData[id as keyof IBooking]) === 'number') {
                    (currentFormData[id as keyof IBooking] as Number) = Number(selection);
                } else {
                    (currentFormData[id as keyof IBooking] as string) = selection;
                }
                setFormData(currentFormData);
            }
        }
    }

    const updateStateProvince = () => {
        if(formData.destinationNation===''){
            let states:ISelectLabel[] =i18n.language==='it'?myCountryArraySelect:myCountryArraySelectEN
            dsDeselectHandler(states)
            setStateOptions(states);
        }else{
            let selectedByLan = i18n.language==='it'?myCountryArraySelect:myCountryArraySelectEN
            setStateOptions(selectedByLan);
            const updatedProvinces = provinceMap[formData.destinationNation] || provinceMap["default"];
            setProvinceOptions(updatedProvinces);
            const selectedState = selectedByLan.find((state) => state.id === formData.destinationNation);
            if (selectedState) {
                dsSelectHandler(selectedByLan, selectedState); // Seleziona lo stato
            }

            // Seleziona la provincia
            const selectedProvince = updatedProvinces.find((province) => province.id === formData.destinationProvince);
            if (selectedProvince) {
                dsSelectHandler(updatedProvinces, selectedProvince); // Seleziona la provincia
            }
        }

        // --- NUOVA PARTE: aggiorna liste per le destinazioni secondarie ---
        if(formData.secondaryDestination && formData.secondaryDestination.length > 0) {
            const newStateOptionsList: ISelectLabel[][] = [];
            const newProvinceOptionsList: ISelectLabel[][] = [];

            formData.secondaryDestination.forEach(addr => {
                // Copia profonda di stati (in base alla lingua)
                let states = i18n.language === 'it' ? myCountryArraySelect.map(s => ({ ...s })) : myCountryArraySelectEN.map(s => ({ ...s }));
                let provinces: ISelectLabel[] = [];

                if(addr.destinationNation === '') {
                    dsDeselectHandler(states);
                    provinces = [];
                } else {
                    // Seleziona stato
                    const foundState = states.find(s => s.id === addr.destinationNation);
                    const fallbackState = states.length > 0 ? { ...states[0], selected: false } : { id: '', label: '', selected: false };
                    dsSelectHandler(states, foundState || fallbackState);

                    // Prepara province con fallback "default"
                    provinces = (provinceMap[addr.destinationNation] || provinceMap["default"]).map(p => ({ ...p }));

                    // Seleziona provincia solo se è presente in formData.secondaryDestination
                    if (provinces.length > 0) {
                        const foundProvince = provinces.find(p => p.id === addr.destinationProvince);
                        if (foundProvince) {
                            dsSelectHandler(provinces, foundProvince);
                        } else {
                            dsDeselectHandler(provinces);
                        }
                    } else {
                        dsDeselectHandler(provinces);
                    }
                }

                newStateOptionsList.push(states);
                newProvinceOptionsList.push(provinces);
            });

            setStateOptionsList(newStateOptionsList);
            setProvinceOptionsList(newProvinceOptionsList);
        } else {
            setStateOptionsList([]);
            setProvinceOptionsList([]);
        }


    }

    useEffect(()=>{
        updateStateProvince();
    },[]);

    useEffect(()=>{
        updateStateProvince();
    },[formData.secondaryDestination]);

    useEffect(()=>{
        updateStateProvince()
    },[i18n.language])

    const getSelectComponent = (id: string, menuLabel: string, menuOptions: ISelectLabel[] | undefined) => {
        return <Select
            id={id}
            menuPlaceholder={t("booking.bookingForm.labels.10")}/*"Seleziona"*/
            hasIcon={false}
            menuOptions={menuOptions === undefined ? [] : menuOptions} //TODO
            menuLabel={menuLabel}
            menuId="select-id"
            isDisabled={
                id === "shipperId" && bookingData.lastMinute
                    ? false
                    : (
                        (
                            (menuOptions === undefined || (!props.edit && (id !== "forcedBay" && id !== "shipperId")) ||
                            bookingData.status === CalendarSlotStatus.CLOSED ||
                            (id === "forcedBay" && bookingData.bayAssignmentAttemptSuccess === null))
                        )
                        ||
                        (
                            (appUserRole === AppUserRole.CUSTOMER ||
                            appUserRole === AppUserRole.CARRIER ||
                            appUserRole === AppUserRole.SALES_PROFILE) && id === "forcedBay"
                        )
                        ||
                        (
                            (appUserRole === AppUserRole.TL_MANAGER ||
                            appUserRole === AppUserRole.BAY_OPERATOR) && id !== "forcedBay"
                        )
                        || (bookingData.salesFreezingTimeStamp < Math.floor(Date.now() / 1000) && id === "shipperId")
                    )
            }
            selectStatus="default"
            onOptionSelection={(event: Event) => {
                onOptionSelect(id, event);
                const selectedOption = (event as CustomEvent).detail.option;
                dsSelectHandler(menuOptions as ISelectLabel[], selectedOption);
            }}
        ></Select>
    }


    const getTextInputComponent = (
        textareaLabel: string,
        textareaId: string,
        textareaDescription: string,
        textareaPlaceholder: string,
        textAreaValue: string,
        index?: number,
        field?: keyof IBookingAddress
    ) => {
       
        return (
            <TextInput
                inputLabel={textareaLabel}
                inputValue={textAreaValue}
                inputId={textareaId}
                inputDescription={textareaDescription}
                input-event-type="single_character"
                isDisabled={
                    (
                            !props.edit //true
                        &&
                            ( 
                                !(
                                    textareaId==="destinationAddress" ||
                                    textareaId==="destinationStreetNumber" ||
                                    textareaId==="destinationCity" ||
                                    textareaId==="destinationPostalCode" ||
                                    textareaId==="destinationBusinessName" ||
                                    textareaId==="destinationVat" ||
                                    textareaId.includes(`destinationAddress-`)||
                                    textareaId.includes(`destinationStreetNumber-`) ||
                                    textareaId.includes(`destinationCity-`) ||
                                    textareaId.includes(`destinationPostalCode-`) ||
                                    textareaId.includes(`destinationBusinessName-`) ||
                                    textareaId.includes(`destinationVat-`)||
                                    textareaId.includes(`preventiveQuantity`) ||
                                    textareaId.includes(`preventiveEnergy`) ||
                                    textareaId==="finalBusiness" 
                                ) 
                            ||
                                (
                                    textareaId.includes(`crossedNation-`)
                                )
                            )
                    ) 

                    || (appUserRole===AppUserRole.TL_MANAGER||appUserRole===AppUserRole.BAY_OPERATOR)
                    || bookingData.status===CalendarSlotStatus.VACANT
                    || ( (bookingData.salesFreezingTimeStamp< Math.floor(Date.now() / 1000)) /*oppure mettere: prereservationSales */ &&(/*textareaId==="preventiveQuantity" || */textareaId==="preventiveEnergy"))
                }
                minValue={0}
                maxDecimalDigits={0}
                isNumberVariant={ 
                    textareaId.startsWith("destinationStreetNumber") || 
                    textareaId.startsWith("destinationPostalCode") ||
                    textareaId.startsWith("preventiveQuantity") ||
                    textareaId.startsWith("preventiveEnergy")
                }
                onInputChange={(inputEvent: Event) => {
                    
                    const value = (inputEvent as CustomEvent).detail.input.value;
                    // Cloniamo formData per aggiornare immutabilmente
                    const updatedFormData = { ...formData };
                    if (textareaId.startsWith("crossedNation") && typeof index === "number") {
                        const crossedNation = [...(updatedFormData.crossedNation || [])];
                        crossedNation[index] = value;
                        updatedFormData.crossedNation = crossedNation;
                    }else if ((textareaId==="preventiveQuantity"||textareaId==="preventiveEnergy")) {
                        (updatedFormData[textareaId as keyof IBooking] as number) = Number(value);
                    } else if (typeof index === "number" && field) {
                        const secondary = [...(updatedFormData.secondaryDestination || [])];
                        const addr = { ...secondary[index] };
                        addr[field] = value;
                        secondary[index] = addr;
                        updatedFormData.secondaryDestination = secondary;
                    } else {
                        (updatedFormData[textareaId as keyof IBooking] as string) = value;
                    }
                    setFormData(updatedFormData);
                }}
            />
        );
    };

    const addCrossedNationField = () => {
        setFormData(prevState => {
            /*const updatedFormData = { ...prevState } ;
            updatedFormData.crossedNation = [...updatedFormData.crossedNation, ""];
            return updatedFormData;*/
            
            const crossedNation = prevState.crossedNation || [];
            const currentLength = crossedNation.length;
            if (currentLength > 0) {
                const lastAddress = crossedNation[currentLength - 1];
                const hasValues =
                    lastAddress.trim() === "";
                if (hasValues) {
                    // Se l'ultimo indirizzo è completamente vuoto nei campi principali,
                    // non aggiungere un nuovo indirizzo
                    return prevState;
                }
            }
            const updatedFormData = { ...prevState } ;
            updatedFormData.crossedNation = [...updatedFormData.crossedNation, ""];
            return updatedFormData;
        });
    };

    const getTimePickerComponent = (id: string, timePickerTitle: string) => {
        return <TimePicker
            id={id}
            timePickerTitle={timePickerTitle} //Orario di inizio*
            startTime={"00:00"}
            endTime={"99:59"}
            timeInterval={30}
            timePickerStatus="default"
            defaultTime={formData.destinationTime}
            isPanelTop={false}
            isDisabled={!props.edit}
            onTimeSelection={(event: Event) => {
                let currentFormData = formData;
                (currentFormData["destinationTime" as keyof IBooking] as string) = (event as CustomEvent).detail.time;
                setFormData(currentFormData);
            }}
        />
    }

    const onSelectInputChange = (event: Event, fieldName: string) => {
    const selection: ISelectLabel = (event as CustomEvent).detail.option;
    const value = selection?.value || "";

    // Controlla se il campo è un path tipo "secondaryDestination.0.destinationNation"
    const pathParts = fieldName.split(".");

    if (pathParts.length > 1 && pathParts[0] === "secondaryDestination") {
        const index = parseInt(pathParts[1], 10);
        const field = pathParts[2];

        if (isNaN(index) || !field) {
        console.warn("Campo secondaryDestination con formato errato:", fieldName);
        return;
        }

        setFormData(prevFormData => {
        const secondary = prevFormData.secondaryDestination ? [...prevFormData.secondaryDestination] : [];

        // Se non esiste l'indirizzo all'indice, crea uno vuoto
        if (!secondary[index]) {
            secondary[index] = {
            destinationAddress: "",
            destinationNation: "",
            destinationStreetNumber: "",
            destinationPostalCode: "",
            destinationCity: "",
            destinationProvince: "",
            destinationBusinessName: "",
            destinationVat: ""  ,
            };
        }

        // Aggiorna solo il campo specificato
        secondary[index] = {
            ...secondary[index],
            [field]: value,
        };

        return {
            ...prevFormData,
            secondaryDestination: secondary,
        };
        });
    } else {
        // Caso normale (campo singolo)
        setFormData(prevFormData => ({
        ...prevFormData,
        [fieldName as keyof IBooking]: value,
        }));
    }
    };

    const loadData = useCallback(() => {
        dispatch(requestPending());

        const shipperListReq = selectorAPI(EntityType.SHIPPER, bookingData.codeIup);
        const serviceListReq = selectorAPI(EntityType.SERVICE, bookingData.codeIup);
        const forcedBayListReq = selectorAPI(EntityType.BAY, bookingData.codeIup);
        const transportListReq = selectorAPI(EntityType.TRANSPORTER, bookingData.codeIup);

        axios.all([ shipperListReq, serviceListReq,forcedBayListReq,transportListReq])
            .then(axios.spread((...responses) => {
                dsPreSelectHandler(responses[0] as ISelectLabel[], bookingData.shipperId);
                setShipperList(responses[0]);
                dsPreSelectHandler(responses[1] as ISelectLabel[], bookingData.service.toString());
                setServiceList(responses[1]);
                dsPreSelectHandler(responses[2] as ISelectLabel[], bookingData.forcedBay.toString());
                setForcedBayList(responses[2]);
                dsPreSelectHandler(responses[3] as ISelectLabel[], bookingData.transporterId.toString());
                setTransportList(responses[3]);
            }))
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                dispatch(requestPristine())
            })


    }, [dispatch]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const getTransporterNameFromList = (transporterId: string): string => {
        if (!transporterId || !transportList || transportList.length === 0) {
            return "";
        }

        const selectedTransporter = transportList.find((transporterOption) => {
            return transporterOption.value === transporterId || transporterOption.id === transporterId;
        });

        return selectedTransporter?.label ?? "";
    }

    const applyAddressOptionToDestination = (addressOption: IAddressOption) => {
        const isValidAddressField = (value: unknown): value is string => {
            return typeof value === "string" && value.trim() !== "";
        };

        const clearedDestinationFields: Pick<IBooking,
            "destinationBusinessName" |
            "destinationAddress" |
            "destinationNation" |
            "destinationStreetNumber" |
            "destinationPostalCode" |
            "destinationCity" |
            "destinationProvince" |
            "destinationVat"
        > = {
            destinationBusinessName: "",
            destinationAddress: "",
            destinationNation: "",
            destinationStreetNumber: "",
            destinationPostalCode: "",
            destinationCity: "",
            destinationProvince: "",
            destinationVat: "",
        };

        const hasNation = isValidAddressField(addressOption.destinationNation);
        const hasProvince = isValidAddressField(addressOption.destinationProvince);

        let selectedNation: ISelectLabel | undefined;
        let selectedProvince: ISelectLabel | undefined;

        if (hasNation) {
            const selectedByLang = i18n.language === "it" ? myCountryArraySelect : myCountryArraySelectEN;
            const states = selectedByLang.map((state) => ({ ...state }));

            selectedNation = states.find((state) => {
                return (
                    state.id?.toUpperCase() === addressOption.destinationNation.toUpperCase() ||
                    state.value?.toUpperCase() === addressOption.destinationNation.toUpperCase()
                );
            });

            if (selectedNation) {
                dsSelectHandler(states, selectedNation);
            } else {
                dsDeselectHandler(states);
            }

            const mappedProvinces = (provinceMap[addressOption.destinationNation] || provinceMap["default"] || []).map((province) => ({ ...province }));

            if (hasProvince) {
                selectedProvince = mappedProvinces.find((province) => {
                    return (
                        province.id?.toUpperCase() === addressOption.destinationProvince.toUpperCase() ||
                        province.value?.toUpperCase() === addressOption.destinationProvince.toUpperCase()
                    );
                });

                if (selectedProvince) {
                    dsSelectHandler(mappedProvinces, selectedProvince);
                } else {
                    dsDeselectHandler(mappedProvinces);
                }
            }

            setStateOptions(states);
            setProvinceOptions(mappedProvinces);
        }

        setFormData((prevFormData) => ({
            ...prevFormData,
            ...clearedDestinationFields,
            ...(isValidAddressField(addressOption.destinationBusinessName) ? { destinationBusinessName: addressOption.destinationBusinessName } : {}),
            ...(isValidAddressField(addressOption.destinationAddress) ? { destinationAddress: addressOption.destinationAddress } : {}),
            ...(hasNation ? { destinationNation: selectedNation?.value || selectedNation?.id || addressOption.destinationNation } : {}),
            ...(isValidAddressField(addressOption.destinationStreetNumber) ? { destinationStreetNumber: addressOption.destinationStreetNumber } : {}),
            ...(isValidAddressField(addressOption.destinationPostalCode) ? { destinationPostalCode: addressOption.destinationPostalCode } : {}),
            ...(isValidAddressField(addressOption.destinationCity) ? { destinationCity: addressOption.destinationCity } : {}),
            ...(hasProvince ? { destinationProvince: selectedProvince?.value || selectedProvince?.id || addressOption.destinationProvince } : {}),
            ...(isValidAddressField(addressOption.destinationVat) ? { destinationVat: addressOption.destinationVat } : {}),
        }));
    }


    const validateCrossedNations = () => {
        let currentFormData = formData;
        let crossedNationsArray = formData.crossedNation;
        let trimmedCrossedNationsArray = [];
        for (let i in crossedNationsArray) {
            if (crossedNationsArray[i] !== "") {
                trimmedCrossedNationsArray.push(crossedNationsArray[i]);
            }
        }
        currentFormData.crossedNation = trimmedCrossedNationsArray;
        setFormData(currentFormData);
    }

    const saveData = () => {
        validateCrossedNations();
        validateSecondaryAddress();
        let err = 0;
        //let err = validateSecondaryAddress();
        if(err===0){
            postBooking(ReservationPostType.UPDATE_DETAILS, {
                ...formData,
                percentageBioLng: formData.bioFlagStatus === false ? 0 : formData.percentageBioLng,
            })
            .then((response) => {
                buildPopUp(dispatch,response,t,t("booking.bookingForm.labels.16"),'OK-422',t("booking.bookingForm.labels.11"),t("booking.bookingForm.labels.12"))
                navigate(RoutePath.B2B_BOOKINGS_INFO);
            })
            .catch(error => {
                let popUpAction: INotificationAction;
                popUpAction = {
                    show: true,
                    title: "Error",
                    description: error,
                    status: "error",
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                console.log(error);
                navigate(RoutePath.B2B_BOOKINGS_INFO);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
        }
    }

    const validateSecondaryAddress = () => {
        let currentFormData = formData;
        const fields: (keyof IBookingAddress)[] = [
                "destinationAddress",
                "destinationStreetNumber",
                "destinationPostalCode",
                "destinationCity",
                "destinationProvince",
                "destinationNation",
            ];
         const filteredSecondary = (formData.secondaryDestination || []).filter(address =>
            fields.some(field => address[field].trim() !== "")
        );
        currentFormData.secondaryDestination = filteredSecondary;
        setFormData(currentFormData);
    }


    const addSecondaryAddressField = () => {
        setFormData(prev => {
            const secondary = prev.secondaryDestination || [];
            const currentLength = secondary.length;

            // Non aggiungere se già 3 o più indirizzi
            if (currentLength >= 3) {
            return prev;
            }

            // Controlla se l'ultimo indirizzo ha i campi obbligatori pieni
            if (currentLength > 0) {
                const lastAddress = secondary[currentLength - 1];
            }

            // Altrimenti aggiungi un nuovo indirizzo vuoto
            const emptyAddress: IBookingAddress = {
            destinationAddress: "",
            destinationNation: "",
            destinationStreetNumber: "",
            destinationPostalCode: "",
            destinationCity: "",
            destinationProvince: "",
            destinationBusinessName: "",
            destinationVat: "" ,
            };

            return {
            ...prev,
            secondaryDestination: [...secondary, emptyAddress],
            };
        });
    };

    const removeSecondaryAddressField = (indexToRemove: number) => {
        setFormData(prev => {
            const updatedSecondary = [...(prev.secondaryDestination || [])];
            updatedSecondary.splice(indexToRemove, 1);
            return {
                ...prev,
                secondaryDestination: updatedSecondary,
            };
        });
        // Aggiorna anche le opzioni se necessario
        setStateOptionsList(prev => prev.filter((_, i) => i !== indexToRemove));
        setProvinceOptionsList(prev => prev.filter((_, i) => i !== indexToRemove));
    };

    return (
        <> 
            <div className="box" style={{ marginTop: '20px', background: layoutMode===DsLayout.DARK_MODE?"#081C3E":"var(--Neutrali-50, #EFF1F5)" }}>
                <div className="boxTitle" style={{ fontSize: '25px' }}>
                    {props.formMode===FormMode.NEW ? 
                        <>{t("booking.bookingForm.title1")} {/**Inserisci i dettagli della prenotazione */}</>
                    :
                        <>{t("booking.bookingForm.title5")}</>
                    }
                    
                </div>
                <Row style={{ marginBottom: "12px" }}>
                    <Col xs={12} md={4}>
                        {getSelectComponent("service", t('calendar.popups.slotBooking.8'), serviceList)}
                        {/*<div style={{fontSize:'80%',marginBottom:'5px',fontWeight:'bold',marginTop:'5px'}}>{t('calendar.popups.slotBooking.8')}</div>
                        <div>{getServiceName(bookingData.service)}</div>*/}
                    </Col>
                    <Col xs={12} md={4}>
                        {formData.shipperName!=='' ?
                            <Output
                                outputTitle={t('booking.bookingData.headers.10')}
                                outputText={bookingData.shipperName}
                                style={{marginBottom:'16px'}}
                            ></Output>
                        :
                            getSelectComponent("shipperId", t("booking.bookingForm.labels.0")+"*"/**Fornitore */, shipperList)
                        }
                    </Col>
                </Row>
                <Row style={{ marginBottom: "12px" }}>
                    <Col xs={12} md={4}>
                        {getSelectComponent("transporterId", t('booking.bookingData.headers.26')+"*"/**trasportarore */, transportList)}
                    </Col>
                    <Col xs={12} md={4}>
                        {getSelectComponent("typeVehicle", t("booking.bookingForm.labels.1")+"*"/**"Tipologia mezzo"*/, typeVehicleList)}
                    </Col>
                </Row>

                {formData.typeVehicle === VehicleType.TANKER && //TIPOLOGIA MEZZO === AUTOBOTTE
                    <>
                        <Row style={{ marginBottom: "12px" }}>
                            <Col xs={12} md={4}>
                                {getSelectComponent("tankerTruck", t("booking.bookingForm.labels.2")+"*"/**"Autobotte"*/, tankerTruckList)}
                            </Col>
                            <Col xs={12} md={4}>
                                {getSelectComponent("truckTractor", t("booking.bookingForm.labels.3")+"*"/**"Trattore"*/, truckTractorList)}
                            </Col>
                        </Row>
                    </>
                }
                {formData.typeVehicle === VehicleType.ISO_CONTAINER && //TIPOLOGIA MEZZO === ISO CONTAINER
                    <>
                        <Row style={{ marginBottom: "12px" }}>
                            <Col xs={12} md={4}>
                                {getSelectComponent("isoContainer", t("booking.bookingForm.labels.4")+"*"/**"Container"*/, isoContainerList)}
                            </Col>
                            <Col xs={12} md={4}>
                                {getSelectComponent("flatBed", t("booking.bookingForm.labels.5")+"*"/**"Pianale"*/, flatBedList)}
                            </Col>
                            <Col xs={12} md={4}>
                                {getSelectComponent("truckTractor", t("booking.bookingForm.labels.3")+"*"/**"Trattore"*/, truckTractorList)}
                            </Col>
                        </Row>
                    </>
                }

                <Row style={{ marginBottom: "12px" }}>
                    <Col xs={12} md={4}>
                        {getSelectComponent("driverId", t("booking.bookingForm.labels.13")+"*"/*"Autista"*/, driversList)}
                    </Col>
                </Row>

                <Row style={{ marginBottom: "12px" }}>
                    {!props.edit && <Col xs={12} md={4}>
                        {getSelectComponent("forcedBay", t("booking.bookingForm.labels.17")/*"ForcedBay"*/, forcedBayList)}
                    </Col>}
                    <Col xs={12} md={4}>
                        <div style={{ fontSize: '80%', marginBottom: '5px', fontWeight: 'bold', marginTop: '5px',color: layoutMode===DsLayout.DARK_MODE?"white":"black" }}>{t("booking.bookingForm.title2")} {/**Baia*/}</div>
                        {bookingData.bay !== "" ? <div style={{ fontSize: '80%',color: layoutMode===DsLayout.DARK_MODE?"white":"black" }}>{bookingData.bay}</div> : <div style={{ fontSize: '80%',color: layoutMode===DsLayout.DARK_MODE?"white":"black" }}>{t("booking.bookingForm.title3")} {/**Verrà assegnata in seguito all'assegnazione del veicolo e visualizzata nella pagina di riepilogo della prenotazione.*/}</div>}
                    </Col>
                </Row>
                <BookingBioFields
                    bookingData={{ ...formData, status: bookingData.status }}
                    onChange={bioData => setFormData(previous => ({ ...previous, ...bioData }))}
                />
                <Row style={{ marginBottom: "12px" }}>
                    <Col xs={12} md={4}>
                        {getTextInputComponent(t("booking.bookingForm.labels.29"), "finalBusiness", "", t("booking.bookingForm.labels.14"), formData.finalBusiness ?? "")}
                    </Col>
                </Row>



                {plantIdValue === SnamPlantKey.PIGNATARO &&
                <Row  style={{ marginBottom: "12px" }}>
                    {/*<Col xs={12} md={4}>
                        {(bookingData.preventiveQuantity!==null ) ?
                            <Output
                                outputTitle={t("booking.bookingForm.labels.27")}
                                outputText = {bookingData.preventiveQuantity?bookingData.preventiveQuantity.toString()+" ton":"-"}
                                style={{marginBottom:'16px'}}
                            ></Output>
                        :
                            getTextInputComponent(
                                t("booking.bookingForm.labels.27"), 
                                `preventiveQuantity`,
                                "",
                                t("booking.bookingForm.labels.14"), // "Inserire testo"
                                formData.preventiveQuantity?formData.preventiveQuantity.toString():""
                            )
                        }
                     </Col>*/}
                     <Col xs={12} md={4}>
                        {(bookingData.preventiveEnergy!==null /*&&bookingData.preventiveEnergy!==""*/) ?
                            <Output
                                outputTitle={t("booking.bookingForm.labels.28")}
                                outputText = {bookingData.preventiveEnergy?bookingData.preventiveEnergy.toString()+" MWh":"-"}
                                style={{marginBottom:'16px'}}
                            ></Output>
                        :
                            getTextInputComponent(
                                t("booking.bookingForm.labels.28"), 
                                `preventiveEnergy`,
                                "",
                                t("booking.bookingForm.labels.14"), // "Inserire testo"
                                formData.preventiveEnergy?formData.preventiveEnergy.toString():""
                            )
                        }
                     </Col>
                </Row>
                }









                { (bookingData.transporterId!== "" || formData.transporterId!== "") &&
                    <Row style={{ marginTop:'25px'}}>
                        <Col xs={12} md={6}>
                            <Accordion
                                accordionUIVariant={"box"} 
                                accordionTitle={`${t("booking.bookingForm.addressesOptions.0")} - ${t("booking.bookingForm.addressesOptions.1")} ${getTransporterNameFromList(formData.transporterId || bookingData.transporterId)}`}
                                accordionId={"accordion"}
                                rightLabel={""}
                                isAccordionOpen={false}
                                >
                                <div slot="content" style={{padding: "0.75rem"}}>
                                    {addressesOptions.map((addressOption, index) => (
                                        <div key={`${addressOption.destinationVat}-${index}`} style={{ marginBottom: "0.75rem" }}>
                                            <h3 className="ff-lato ff-title-2xs" style={{color: "var(--text-reading-1)", margin: "0 0 0.5rem"}}>
                                                {`${addressOption.destinationBusinessName ?? ""}`}
                                            </h3>
                                            <p className="ff-lato ff-body-m" style={{color: "var(--text-reading-1)", margin: "0"}}>
                                                {`${addressOption.destinationAddress ?? ""} ${addressOption.destinationStreetNumber ?? ""} ${addressOption.destinationPostalCode ?? ""} ${addressOption.destinationCity ?? ""} ${(addressOption.destinationProvince) ?? ""} ${addressOption.destinationNation ?? ""} ${addressOption.destinationVat ?? ""}` }
                                            </p>
                                            <div style={{ textAlign: "right", marginTop: "0.5rem" }}>
                                                <Button
                                                    buttonType="button"
                                                    buttonUIVariant={"secondary"}
                                                    buttonSize="small"
                                                    buttonLabel={t("booking.bookingForm.addressesOptions.3")}
                                                    buttonAriaLabel="new entity button"
                                                    onClickEvent={() => {
                                                        applyAddressOptionToDestination(addressOption)
                                                    }}
                                                ></Button>
                                            </div>
                                        </div>
                                    ))}
                                    {addressesOptions.length === 0 && (
                                        <p className="ff-lato ff-body-m" style={{color: "var(--text-reading-1)", margin: "0"}}>
                                            Nessuna destinazione disponibile per il trasportatore selezionato.
                                        </p>
                                    )}
                                </div>
                            </Accordion>
                        </Col>
                    </Row>
                }





                <Row style={{ marginBottom: "12px", marginTop: '30px' }}>
                    <Col xs={12} md={4}>
                        {getTextInputComponent(t("booking.bookingForm.labels.6")+"*", "destinationAddress", "", t("booking.bookingForm.labels.14")/*"Inserire testo"*/, formData.destinationAddress)}
                    </Col>
                    <Col xs={12} md={2}>
                        {getTextInputComponent(t("booking.bookingForm.labels.18")+"*", "destinationStreetNumber", "", t("booking.bookingForm.labels.14")/*"Inserire testo"*/, formData.destinationStreetNumber)}
                    </Col>
                    <Col xs={12} md={2}>
                        {/*getTextInputComponent(t("booking.bookingForm.labels.7"), "destinationNation", "", t("booking.bookingForm.labels.14"), formData.destinationNation)*/}
                        {i18n.language&&<Select
                            id={'id-select-nation'}
                            menuPlaceholder={t("booking.bookingForm.labels.7")}//Stato
                            hasIcon={false}
                            menuOptions={stateOptions}
                            menuLabel={t("booking.bookingForm.labels.7")+"*"}//Stato
                            menuId="select-id"
                            isDisabled={/*!props.edit*/(appUserRole===AppUserRole.TL_MANAGER||appUserRole===AppUserRole.BAY_OPERATOR)||bookingData.status===CalendarSlotStatus.VACANT}
                            selectStatus="default"
                            onOptionSelection={(event: Event) => {
                                const selection: ISelectLabel = (event as CustomEvent).detail.option;
                                dsSelectHandler(stateOptions!, selection);
                                            
                                //aggiorna province
                                const updatedProvinces = provinceMap[selection.value!] || provinceMap["default"];
                                dsDeselectHandler(updatedProvinces)
                                setProvinceOptions(updatedProvinces);
                                            
                                // Pulisci il valore della provincia (stringa vuota)
                                if (JSON.stringify(updatedProvinces) !== JSON.stringify(provinceOptions)) {
                                    onSelectInputChange({ detail: { option: { value: '' } } } as unknown as CustomEvent, "destinationProvince");
                                }
                                                            
                                onSelectInputChange(event,"destinationNation")
                            }}
                        ></Select>}
                    </Col>
                    <Col xs={12} md={2}>
                        {/*getTextInputComponent(t("booking.bookingForm.labels.21"), "destinationProvince", "", t("booking.bookingForm.labels.14"), formData.destinationProvince)*/}
                        <Select
                            id="id-select-province"
                            menuPlaceholder={t("booking.bookingForm.labels.21")}//Provincia
                            menuOptions={provinceOptions} // Opzioni province dinamiche
                            menuLabel={t("booking.bookingForm.labels.21")+"*"}//Provincia
                            isDisabled={/*(!props.edit)||*/(provinceOptions.length === 0) || (appUserRole===AppUserRole.TL_MANAGER||appUserRole===AppUserRole.BAY_OPERATOR)||bookingData.status===CalendarSlotStatus.VACANT}
                            onOptionSelection={(event: Event) => {
                                const selection: ISelectLabel = (event as CustomEvent).detail.option;
                                dsSelectHandler(provinceOptions!, selection);
                                onSelectInputChange(event, "destinationProvince")
                            }}
                        />
                    </Col>
                </Row>
                <Row style={{ marginBottom: "12px", marginTop: '30px' }}>
                    <Col xs={12} md={4}>
                        {getTextInputComponent(t("booking.bookingForm.labels.19")+"*", "destinationCity", "", t("booking.bookingForm.labels.14")/*"Inserire testo"*/, formData.destinationCity)}
                    </Col>
                    <Col xs={12} md={2}>
                        {getTextInputComponent(t("booking.bookingForm.labels.20")+"*", "destinationPostalCode", "", t("booking.bookingForm.labels.14")/*"Inserire testo"*/, formData.destinationPostalCode)}
                    </Col>
                    <Col xs={12} md={2}>
                        {getTextInputComponent(t("booking.bookingForm.labels.25")+"*", "destinationBusinessName", "", t("booking.bookingForm.labels.14")/*"Inserire testo"*/, formData.destinationBusinessName)}
                    </Col>
                    <Col xs={12} md={2}>
                        {getTextInputComponent(t("booking.bookingForm.labels.26")+"*", "destinationVat", "", t("booking.bookingForm.labels.14")/*"Inserire testo"*/, formData.destinationVat)}
                    </Col>
                    
                </Row>
                    {formData.secondaryDestination?.map((address, index) => (
                        <React.Fragment key={index} >
                            <div className="listTableContainerDarkGrey">
                            <Row style={{marginTop:'-20px'}}>
                                <Col>
                                    <div className="formSubTitle" style={{ margin: "24px 0 24px", fontFamily: "Lato, Lato-local, sans-serif", fontSize: "20px", fontWeight: 700 }}>
                                        {t('booking.bookingForm.labels.23')+" "+`${index+2}`}
                                    </div>
                                </Col>
                                <Col></Col>
                                <Col></Col>
                                <Col xs={12} md={3} style={{ marginTop: '20px' }}>
                                    <Button
                                        buttonType="button"
                                        buttonUIVariant="secondary"
                                        buttonSize="medium"
                                        buttonIcon="icon-delete-1"
                                        buttonLabel={t('general.buttons.delete', { ns: 'app' })+" "+t('booking.bookingForm.labels.24')}
                                        onClickEvent={() => removeSecondaryAddressField(index)}
                                        isDisabled={/*!props.edit*/false}
                                        style={{float:'right'}}
                                    />
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: "12px"}}>
                                <Col xs={12} md={4}>
                                    {getTextInputComponent(
                                        t("booking.bookingForm.labels.6")+" "+`${index+2}`, // "Indirizzo"
                                        `destinationAddress-${index}`,
                                        "",
                                        t("booking.bookingForm.labels.14"), // "Inserire testo"
                                        address.destinationAddress,
                                        index,
                                        "destinationAddress"
                                    )}
                                </Col>
                                <Col xs={12} md={2}>
                                    {getTextInputComponent(
                                        t("booking.bookingForm.labels.18")+" "+`${index+2}`, // "Indirizzo"
                                        `destinationStreetNumber-${index}`,
                                        "",
                                        t("booking.bookingForm.labels.14"), // "Inserire testo"
                                        address.destinationStreetNumber,
                                        index,
                                        "destinationStreetNumber"
                                    )}
                                </Col>
                                <Col xs={12} md={2}>
                                    {i18n.language&&<Select
                                        id={`destinationNation-${index}`}
                                        selectId={`destinationNation-${index}`}
                                        menuPlaceholder={t("booking.bookingForm.labels.7")}//Stato
                                        hasIcon={false}
                                        menuOptions={stateOptionsList[index] || []}
                                        menuLabel={t("booking.bookingForm.labels.7")+" "+`${index+2}`}//Stato
                                        menuId="select-id"
                                        isDisabled={/*!props.edit*/(appUserRole===AppUserRole.TL_MANAGER||appUserRole===AppUserRole.BAY_OPERATOR)||bookingData.status===CalendarSlotStatus.VACANT}
                                        selectStatus="default"
                                        onOptionSelection={(event: Event) => {
                                             const selection: ISelectLabel = (event as CustomEvent).detail.option;

                                            // Aggiorna la selezione nello stato corrispondente
                                            const updatedStates = [...(stateOptionsList[index] || [])];
                                            dsSelectHandler(updatedStates, selection);

                                            // Aggiorna province relative allo stato selezionato
                                            const updatedProvinces = provinceMap[selection.value!] ? provinceMap[selection.value!].map(p => ({ ...p })) : [];
                                            dsDeselectHandler(updatedProvinces);

                                            // Aggiorna le liste globali mantenendo le altre intatte
                                            setStateOptionsList(prev => {
                                                const copy = [...prev];
                                                copy[index] = updatedStates;
                                                return copy;
                                            });

                                            setProvinceOptionsList(prev => {
                                                const copy = [...prev];
                                                copy[index] = updatedProvinces;
                                                return copy;
                                            });

                                            // Pulisci valore provincia nel form (chiama la callback per aggiornare formData)
                                            onSelectInputChange(
                                                { detail: { option: { value: '' } } } as unknown as CustomEvent,
                                                `secondaryDestination.${index}.destinationProvince`
                                            );

                                            // Aggiorna selezione stato nel form
                                            onSelectInputChange(event, `secondaryDestination.${index}.destinationNation`);
                                        }}
                                    ></Select>}
                                </Col>
                                <Col xs={12} md={2}>
                                    <Select
                                        id={`destinationProvince-${index}`}
                                        selectId={`destinationProvince-${index}`}
                                        menuPlaceholder={t("booking.bookingForm.labels.21")}//Provincia
                                        menuOptions={provinceOptionsList[index] || []} // Opzioni province dinamiche
                                        menuLabel={t("booking.bookingForm.labels.21")+" "+`${index+2}`}//Provincia
                                        isDisabled={/*(props.edit) &&*/  ((provinceOptionsList[index]) && (provinceOptionsList[index].length === 0)) || (appUserRole===AppUserRole.TL_MANAGER||appUserRole===AppUserRole.BAY_OPERATOR)||bookingData.status===CalendarSlotStatus.VACANT}
                                        onOptionSelection={(event: Event) => {
                                            const selection: ISelectLabel = (event as CustomEvent).detail.option;

                                            const updatedProvinces = [...(provinceOptionsList[index] || [])];
                                            dsSelectHandler(updatedProvinces, selection);

                                            setProvinceOptionsList(prev => {
                                            const copy = [...prev];
                                            copy[index] = updatedProvinces;
                                            return copy;
                                            });

                                            onSelectInputChange(event, `secondaryDestination.${index}.destinationProvince`);
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: "12px", marginTop: '30px' }}>
                                <Col xs={12} md={4}>
                                    {getTextInputComponent(
                                        t("booking.bookingForm.labels.19")+" "+`${index+2}`, // "Indirizzo"
                                        `destinationCity-${index}`,
                                        "",
                                        t("booking.bookingForm.labels.14"), // "Inserire testo"
                                        address.destinationCity,
                                        index,
                                        "destinationCity"
                                    )}
                                </Col>
                                <Col xs={12} md={2}>
                                    {getTextInputComponent(
                                        t("booking.bookingForm.labels.20")+" "+`${index+2}`, // "Indirizzo"
                                        `destinationPostalCode-${index}`,
                                        "",
                                        t("booking.bookingForm.labels.14"), // "Inserire testo"
                                        address.destinationPostalCode,
                                        index,
                                        "destinationPostalCode"
                                    )}
                                </Col>

                                <Col xs={12} md={2}>
                                    {getTextInputComponent(
                                        t("booking.bookingForm.labels.25")+" "+`${index+2}`, // "destinationBusinessName"
                                        `destinationBusinessName-${index}`,
                                        "",
                                        t("booking.bookingForm.labels.14"), // "Inserire testo"
                                        address.destinationBusinessName,
                                        index,
                                        "destinationBusinessName"
                                    )}
                                </Col>
                                <Col xs={12} md={2}>
                                    {getTextInputComponent(
                                        t("booking.bookingForm.labels.26")+" "+`${index+2}`, // "destinationVat"
                                        `destinationVat-${index}`,
                                        "",
                                        t("booking.bookingForm.labels.14"), // "Inserire testo"
                                        address.destinationVat,
                                        index,
                                        "destinationVat"
                                    )}
                                </Col>
                                
                            </Row>
                        </div>
                        </React.Fragment>
                    ))}
                    
                    {formData.secondaryDestination.length<3 && <Row style={{ marginBottom: "12px", marginTop: '30px' }}>
                        <Col xs={12} md={3} style={{ marginTop: '10px' }}>
                            <Button
                                style={{ float: 'left', marginTop: '20px' }}
                                id="addSecondaryAddressButton"
                                buttonType="button"
                                buttonUIVariant="secondary"
                                buttonSize="medium"
                                buttonLabel={t("booking.bookingForm.labels.22")} // es. "Aggiungi indirizzo secondario"
                                buttonIcon="icon-add"
                                isDisabled={(appUserRole===AppUserRole.TL_MANAGER||appUserRole===AppUserRole.BAY_OPERATOR)||bookingData.status===CalendarSlotStatus.VACANT}
                                onClickEvent={() => {
                                    addSecondaryAddressField(); 
                                }}
                            />
                        </Col>
                    </Row>}
                
                <Row style={{ marginBottom: "12px" }}>
                    {/*<Col xs={12} md={4}>
                        {getTextInputComponent("Nazione percorsa*","crossedNation","Inserisci le nazioni separate da un punto e virgola","Inserire testo",formData.crossedNation)}
                    </Col>*/}
                    {formData.crossedNation.map((nation, index) => (
                        <Col key={index} xs={12} md={4} style={{ marginTop: '10px', marginRight: '0px' }}>
                            {getTextInputComponent(
                                `${t("booking.bookingData.headers.17")} ${index + 1}`,
                                `crossedNation-${index}`,
                                t("booking.bookingForm.labels.15")/*"Inserisci la nazione"*/,
                                t("booking.bookingForm.labels.14")/*"Inserire testo"*/,
                                nation,
                                index
                            )}
                        </Col>
                    ))}
                </Row>
                <Row>
                    <Col xs={12} md={3} style={{ marginTop: '12px' }}>
                        <Button
                            style={{ float: 'left', marginTop: '20px' }}
                            id="backButton"
                            buttonType="button"
                            buttonUIVariant="secondary"
                            buttonSize="medium"
                            buttonLabel={t("booking.bookingForm.labels.8")}//"Aggiungi transito"
                            buttonIcon="icon-add"
                            isDisabled={(appUserRole===AppUserRole.TL_MANAGER||appUserRole===AppUserRole.BAY_OPERATOR) || !props.edit}
                            onClickEvent={() => {
                                addCrossedNationField()
                            }}
                        />
                    </Col>
                </Row>
                {(formData && formData.typeVehicle === VehicleType.ISO_CONTAINER) && <>
                    <Row style={{ marginBottom: "12px" }}>
                        <Col xs={12} md={4}>
                            <div style={{ fontSize: '80%', marginBottom: '5px', marginTop: '30px', fontWeight: 'bold' }}>{t("booking.bookingForm.title4")} {/**Tempo per raggiungere la destinazione*/}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={4}>
                            {getTimePickerComponent("timePicker-id", t("booking.bookingForm.labels.9")/*"Ore e minuti*"*/)}
                        </Col>
                    </Row></>}
            </div>

            {bookingData.status!==CalendarSlotStatus.VACANT && <Button
                style={{ float: 'right', marginLeft: '10px', marginTop: '20px' }}
                id="backButton"
                buttonType="button"
                buttonUIVariant="primary"
                buttonSize="medium"
                buttonLabel={t('general.buttons.save', { ns: 'app' })}//"Continua"
                buttonIcon=""
                isDisabled={!isBookingBioPercentageValid(formData)}
                onClickEvent={() => {
                    //console.log(formData)
                    saveData();
                }}
            />}
        </>
    );
}

export default BookingReservationForm;